var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2192_38050)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2192_38050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.55978 20H28.4402C29.3043 19.9531 30 19.2604 30 18.4219V1.57812C30 0.713542 29.2663 0.00520833 28.3641 0H1.63587C0.733696 0.00520833 0 0.713542 0 1.57812V18.4167C0 19.2604 0.695652 19.9531 1.55978 20Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9022 11.9948V20H17.0761V11.9948H30V7.99479H17.0761V0H12.9022V7.99479H0V11.9948H12.9022Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4678 6.47396V0H28.3754C29.0602 0.0104167 29.6471 0.421875 29.8863 1L18.4678 6.47396Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4678 13.5259V19.9998H28.4406C29.0982 19.9634 29.6526 19.5571 29.8863 18.9998L18.4678 13.5259Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.511 13.5259V19.9998H1.55991C0.902301 19.9634 0.342519 19.5571 0.114258 18.9894L11.511 13.5259Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.511 6.47396V0H1.62513C0.940345 0.0104167 0.347953 0.427083 0.114258 1.01042L11.511 6.47396Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66667H4.15761L0 4.67188V6.66667Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 6.66683H25.8203L29.9997 4.66162V6.66683Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 13.3335H25.8203L29.9997 15.3387V13.3335Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3335H4.15761L0 15.3283V13.3335Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 1.69287L19.6465 6.66683H21.9617L29.9997 2.81266V1.69287Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3315 13.3335H8.0163L0 17.1772V18.297L10.3533 13.3335H10.3315Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71739 6.67204H8.03261L0 2.81787V3.93245L5.71739 6.67204Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2556 13.3281H21.9404L30.0002 17.1979V16.0833L24.2556 13.3281Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2192_38050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2192_38050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/english_flag.e26ba9cc88da6bfde94b6db4de7220e3.svg";
export { ForwardRef as ReactComponent };